import { Fragment, lazy, Suspense, useContext, useEffect, useRef } from "react";
import { Route, Routes } from "react-router-dom";
import AuthContext from "../Hooks/AuthContext/AuthContext";
import AdminDashboardLayout from "../Layouts/AdminDashboardLayout";
import SuspenseScreen from "./SuspenseScreen";
import { Navigate } from "react-router-dom";
import PagesLayout from "../Layouts/PagesLayout";

const Router = () => {
  const { auth, init } = useContext(AuthContext);
  const storedToken = localStorage.getItem("token");
  const storedRole = localStorage.getItem("role");
  const isSignedIn = Boolean(auth?.is_logged_in || storedToken);
  const homePath = isSignedIn
    ? ((auth?.role || storedRole) === "agent" ? "/admin/agent-dashboard" : (auth?.role || storedRole) === "staff" ? "/staff/payslips" : "/admin")
    : "/login";
  const routes: any = [
    {
      path: "/signUp",
      element: lazy(() => import("../Pages/SignUp")),
    },

    {
      path: "/admin/*",
      layout: AdminDashboardLayout,
      element: lazy(() => import("../Layouts/AdminDashboardLayout")),
      subRoutes: [
        {
          path: "",

          element: lazy(() => import("../Pages/Dashboard")),
        },
        {
          path: "resumes",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/Resumes")),
        },
        {
          path: "countries",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/Countries")),
        },
        {
          path: "no_passports",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/NoPassport")),
        },
        {
          path: "recruitments",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/Recruitments")),
        },
        {
          path: "registrations",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/Registrations")),
        },
        {
          path: "tickets",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/Tickets")),
        },
        {
          path: "complaints",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/Complaints")),
        },
        {
          path: "finance-management",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/FinanceManagement")),
        },
        {
          path: "financial-reports",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/FinancialReports")),
        },
        {
          path: "complaint-reports",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/ComplaintReports")),
        },
        {
          path: "countryProcess",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/CountryProcess")),
        },
        {
          path: "countryTemplate",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/CountryTemplate")),
        },

        {
          path: "jobTitles",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/JobTitles")),
        },
        {
          path: "processes",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/Processes")),
        },
        {
          path: "process-view",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/ProcessView")),
        },
        {
          path: "skills",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/Skills")),
        },
        {
          path: "resume-view/:id",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/ResumeView")),
        },
        {
          path: "subAgent",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/SubAgent")),
        },
        {
          path: "staff",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/Staff")),
        },
        {
          path: "salary-management",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/SalaryManagement")),
        },
        {
          path: "eventLog",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/EventLog")),
        },
        {
          path: "pdf",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/PDFDocument")),
        },
        {
          path: "passports",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/Passports")),
        },
        {
          path: "country-agents",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/CountryAgents")),
        },
        {
          path: "agent-dashboard",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/AgentPortal/AgentDashboard")),
        },
        {
          path: "agent-cv-assignments",
          layout: PagesLayout,
          element: lazy(() => import("../Pages/AgentPortal/AgentCVAssignmentsPage")),
        },
      ],
    },
    {
      path: "/login",
      element: lazy(() => import("../Pages/Login")),
    },
    {
      path: "/agent/login",
      element: lazy(() => import("../Pages/AgentPortal/AgentLoginPage")),
    },
    {
      path: "/staff/login",
      element: lazy(() => import("../Pages/StaffLogin")),
    },
    {
      path: "/staff/payslips",
      element: lazy(() => import("../Pages/StaffPayslips")),
    },
    {
      path: "/candidate/login",
      element: lazy(() => import("../Pages/CandidatePortal/CandidateLoginPage")),
    },
    {
      path: "/candidate/dashboard",
      element: lazy(() => import("../Pages/CandidatePortal/CandidateDashboard")),
    },
  ];

  const RouteRender = (route: any, i: number) => {
    const Element = route.element ? route.element : Fragment;
    const Layout = route.layout ? route.layout : Fragment;

    return (
      // <Route
      //   key={i}
      //   index={route.path ? false : true}
      //   path={route.path}
      //   element={
      //     <Layout>
      //       <Suspense fallback={<SuspenseScreen />}>
      //         {route.subRoutes ? (
      //           <Routes>
      //             {route.subRoutes.map((subRoute: any, index: any) => {
      //               const SubElement = subRoute.element;
      //               return (
      //                 <Route
      //                   path={subRoute.path}
      //                   element={
      //                     <Suspense fallback={<SuspenseScreen />}>
      //                       {" "}
      //                       <SubElement />
      //                     </Suspense>
      //                   }
      //                   key={"admin" + index}
      //                 />
      //               );
      //             })}
      //           </Routes>
      <Route
        key={i}
        index={route.path ? false : true}
        path={route.path}
        element={
          <Layout>
            <Suspense fallback={<SuspenseScreen />}>
              {route.subRoutes ? (
                <Routes>
                  {route.subRoutes.map((subRoute: any, index: any) => {
                    const SubElement = subRoute.element;
                    const SubLayout = subRoute.layout
                      ? subRoute.layout
                      : Fragment;

                    return (
                      <Route
                        path={subRoute.path}
                        element={
                          <SubLayout>
                            <Suspense fallback={<SuspenseScreen />}>
                              <SubElement />
                            </Suspense>
                          </SubLayout>
                        }
                        key={"admin" + index}
                      />
                    );
                  })}
                </Routes>
              ) : (
                <Element />
              )}
            </Suspense>
          </Layout>
        }
      ></Route>
    );
  };

  const initRef = useRef(init);
  useEffect(() => { initRef.current = init; }, [init]);
  useEffect(() => { initRef.current(); }, []);
  return (
    <>
      <Routes>
        <Route path="/" element={<Navigate to={homePath} replace />} />
        {routes.map(RouteRender)}
        <Route path="*" element={<Navigate to={homePath} replace />} />
      </Routes>
    </>
  );
};

export default Router;
